'use strict';

import * as Sentry from '@sentry/react';

import AuthStore from '@stores/AuthStore';
import UserStore from '@stores/UserStore';

export function fetchProviderConnected(provider, abortController = null, isRetry = false) {
    const links = UserStore.getLinks && UserStore.getLinks();
    const providersUrl = links && links.providers;
    if (!providersUrl) {
        return Promise.resolve(false);
    }

    return AuthStore.fetch(
        `${providersUrl}?provider=${provider}`,
        {
            method: 'GET',
            headers: { 'Content-Type': 'application/json; schema=provider/1' },
            body: null,
        },
        false,
        false,
        abortController
    )
        .then((response) => !!(
            response &&
            response.user_provider &&
            response.user_provider.user_profile
        ))
        .catch((reason) => {
            if (abortController && abortController.signal.aborted) {
                return false;
            }
            if (!isRetry) {
                return fetchProviderConnected(provider, abortController, true);
            }
            Sentry.captureException(reason, {
                tags: { util: 'ProviderConnection' },
                extra: { context: 'fetchProviderConnected', provider },
            });
            return false;
        });
}
